import styled from '@emotion/styled'
import ReactFocusLock from 'react-focus-lock'
import { RemoveScroll } from 'react-remove-scroll'
import { pxToRem } from 'utils/styled'

export const SModal = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
`

export const SFocusLock = styled(ReactFocusLock)`
  height: 100%;
  width: 100%;
`

export const SModalTopBar = styled.div`
  position: absolute;
  top: 0;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${pxToRem(12)}rem;
  display: flex;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
  z-index: 2;
  width: 100%;
  transition: opacity 0.3s;
`

export const SModalContent = styled(RemoveScroll)`
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
  align-items: center;
  justify-content: center;
`

export const SModalBottomBar = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: ${pxToRem(12)}rem;
  display: flex;
`
